import { State } from 'store/types';
import { useStoreon } from 'storeon/react';

export const isCheckout = (path: string): boolean => path.replace(/\//g, '') === 'checkout';

export const useIsCheckout = (): boolean => {
  const { path } = useStoreon<State>('path');
  return isCheckout(path);
};
